'use strict'

exports.url = () =>{
     return 'https://laason.mx/api/adE_ldk/M3q-2dF';
     //return 'http://localhost:3200/api/adE_ldk/M3q-2dF';
}